export default __webpack_public_path__ + "static/media/ok1.f3f2de20.png";